module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-solid-rounded-UWVI4CEC.woff?9ce0ef5e6fa829ac32bd5acb7fcc98fb";